const TOTAL_WIDTH = 320;
export const calculateProgressWidths = (stepCount, isSimpleSteps) => {
    // if not simple steps, we need to subtract 1 from the step count as the last item doesn't have a line
    const stepsToUse = isSimpleSteps ? stepCount : stepCount - 1;
    return {
        totalWidth: TOTAL_WIDTH,
        stepWidth: TOTAL_WIDTH / stepsToUse,
    };
};
export const calculateStepState = (index, currentStepIndex) => {
    if (index === currentStepIndex) {
        return 'current';
    }
    else if (index < currentStepIndex || currentStepIndex === -1) {
        return 'completed';
    }
    return 'disabled';
};
//# sourceMappingURL=helpers.js.map